// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Checkbox.scss';

import type { Node } from 'react';

export type Color = 'lightBlue' | 'orange';

type Props = {
  +isChecked: boolean;
  +handleChange: (e: Event) => void;
  +name: string;
  +value: string;
  +children?: Node;
  +color?: Color;
  +disabled?: boolean;
  +className?: string;
};

export default class Checkbox extends Component<Props, void> {
  static defaultProps = {
    isChecked: false,
    color: 'lightBlue',
    disabled: false,
  };

  render() {
    const { isChecked, handleChange, className, name, value, children, color, disabled } = this.props;
    return (
      <label className={classNames(style.checkboxWrap, className)}>
        <input type="checkbox"
               name={name}
               value={value}
               checked={isChecked}
               onChange={handleChange}
               disabled={disabled}
        />
        <span className={classNames(style.checkmark, style[color])}/>
        <span className={classNames(style.content, style[color])}>{children}</span>
      </label>
    );
  }
}

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  children: PropTypes.node,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/elements/Checkbox/Checkbox.jsx